import { validateEmail } from '../../utils/validation'
import { ID } from '../../types/id'
import { InquiryFormType } from '../../utils/constants'
import * as yup from 'yup'
import { SpeLevel } from '../../utils/constants'

export type Inquiry = {
  id?: ID
  code?: string
  type: InquiryFormType['name']
  email: string
  spe: SpeLevel
  send: boolean
  inquiryStatus: InquiryStatus
}

export type InquiryResponse = Inquiry & {
  id: string
}

type Parent = Inquiry & {
  role: null
}
type Tutor = Inquiry & {
  role: null | number
}

export type Inquiries = {
  id?: ID
  examinationId: number
  examinationCode: string
  parent1Email: string
  parent2Email: string
  tutor1Email: string
  tutor2Email: string
  parent1: Parent | null
  parent2: Parent | null
  tutor1: Tutor | null
  tutor2: Tutor | null
  mentalLevel?: string | null
}

type InquryRequest = {
  inquiry: Inquiry
}
export const disabilityLevel = ['Głęboki', 'Umiarkowany', 'Znaczny']
export const reportType = ['Wszystkich', 'Pojedynczy', 'Skali']

export const inquiryStatus = [
  'NOT_ORDERED',
  'PENDING_DELIVERY',
  'DELIVERY_FAILED',
  'DELIVERED',
  'ANSWERED_BY_LINK',
  'ANSWERED_ON_BEHALF',
] as const

export type InquiryStatus = typeof inquiryStatus[number]

// export function filterAvailableInquiryTypes() {}

export const inquirySchema = yup.object().shape(
  {
    email: yup
      .string()
      .when('type', {
        is: (val) => val !== '',
        then: yup.string().email('Niepoprawny email').required('Pole wymagane'),
      })
      .matches(
        /^$|^[-\w.!#$%&'*+=?`(){|}~^-]+@([-\w]+\.)+[a-z]+$/i,
        'Niepoprawny email'
      )
      .when('send', {
        is: true,
        then: yup.string().email('Niepoprawny email').required('Pole wymagane'),
        otherwise: yup.string().notRequired(),
      }),
    type: yup.string().when('send', {
      is: true,
      then: yup.string().required('Pole wymagane'),
      otherwise: yup.string().notRequired(),
    }),
  },
  [
    ['email', 'type'],
    ['email', 'send'],
    ['type', 'send'],
  ]
)

export const addInquirySchema = yup.object({
  parent1: inquirySchema,
  parent2: inquirySchema,
  tutor1: inquirySchema,
  tutor2: inquirySchema,
  mentalLevel: yup.lazy((value) => {
    if (value === undefined) {
      return yup.mixed().notRequired()
    } else {
      return yup.string().required('Pole wymagane')
    }
  }),
})
